import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 1,
    class: "p-5"
};
const _hoisted_3 = { class: "subtitle" };
const _hoisted_4 = { class: "columns" };
const _hoisted_5 = { class: "column" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Device Pairing Code", -1);
const _hoisted_7 = {
    key: 0,
    class: "column"
};
const _hoisted_8 = { class: "message is-small is-danger" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "message-header" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "Network Admin Controls")
], -1);
const _hoisted_10 = { class: "message-body" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Profile", -1);
const _hoisted_13 = { class: "columns" };
const _hoisted_14 = { class: "columns" };
const _hoisted_15 = { class: "columns" };
const _hoisted_16 = { key: 1 };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Attachments", -1);
const _hoisted_18 = { class: "columns is-multiline" };
const _hoisted_19 = { class: "label" };
const _hoisted_20 = { key: 2 };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Preferences", -1);
const _hoisted_22 = { key: 0 };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Admin Settings", -1);
const _hoisted_25 = { class: "columns is-mobile" };
const _hoisted_26 = { class: "column" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, "Features", -1);
const _hoisted_29 = { class: "columns is-mobile" };
const _hoisted_30 = { class: "column" };
const _hoisted_31 = { key: 3 };
const _hoisted_32 = { key: 4 };
const _hoisted_33 = { class: "columns" };
const _hoisted_34 = { class: "columns" };
import DocumentUploadWidget from "@/components/DocumentUploadWidget.vue";
import FormSelectField from "@/components/FormSelectField.vue";
import { useAsync } from "@/composables/useAsync";
import { Validations, useValidation } from "@/composables/useValidation";
import { ProfileTypes, Core, Feature } from '@minicity/core';
import { canSeeFeature, isFeatureEnabled, isNetworkAdmin, sessionState } from "@/core/session";
import { notifyNetworkError, notifySuccess } from "@/core/utils";
import { apiPartnerOnboarding } from "@/features/partnerOnboarding/api";
import { PartnerPlan } from "@/features/partnerOnboarding/model";
import { onMounted, ref, watch } from "vue";
import { apiPartners } from "./api";
import FormStringListField from "@/components/FormStringListField.vue";
import { watchQueryParam } from "@/composables/watchQueryParam";
var Tab;
(function (Tab) {
    Tab["DETAILS"] = "Partner Details";
    Tab["ATTACHMENTS"] = "Attachments";
    Tab["PREFERENCES"] = "Preferences & Settings";
    Tab["COMMENTS"] = "Comments";
    Tab["TASKS"] = "Tasks";
})(Tab || (Tab = {}));
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerDetailPanel',
    props: {
        partnerId: {}
    },
    setup(__props) {
        const props = __props;
        const partner = useAsync();
        onMounted(() => {
            if (!sessionState.session)
                return;
            partner.fetch(apiPartners.get(props.partnerId), "Failed to load partner");
            if (new URL(window.location.toString()).searchParams.has('taskId')) {
                activeTab.value = Tab.TASKS;
            }
        });
        // Tabs
        const activeTab = ref(Tab.DETAILS);
        watch(activeTab, watchQueryParam(activeTab, 'tab'));
        // UI state
        const inProgressAction = ref(null);
        // Partner approval
        const approvePartnerModalActive = ref(false);
        const { areAllFieldsValid: areAllPartnerApprovalFieldsValid, validator: partnerApprovalValidator } = useValidation();
        const partnerApproval = ref({
            subscriptionConfig: {
                plan: PartnerPlan.PRO,
                trialEndDate: null,
                accountCredit: 0,
                stripeCustomerId: ""
            }
        });
        const moment = require('moment');
        let baseDate = moment().startOf('month');
        const availableTrialEndDates = {};
        for (let monthsAhead = 1; monthsAhead <= 24; ++monthsAhead) {
            let monthStartDate = baseDate.add(1, 'M');
            availableTrialEndDates[monthStartDate.format('MMMM YYYY')] = monthStartDate.unix() * 1000;
        }
        const approvePartner = () => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `approvePartner`;
            apiPartnerOnboarding.approvePartner(partner.data.id, partnerApproval.value)
                .then(() => {
                partner.data.isPendingApproval = false;
                partner.data.shown = true;
                approvePartnerModalActive.value = false;
                notifySuccess("Partner approved");
            })
                .catch(err => notifyNetworkError("Failed to approve partner", err))
                .finally(() => inProgressAction.value = null);
        };
        // Actions
        const saveProfile = () => {
            if (inProgressAction.value)
                return;
            /*if (!areAllFieldsValid.value) {
              notifyError("Please check for invalid form inputs");
              return;
            }
            else {
              doSaveProfile();
            }*/
            doSaveProfile();
        };
        const doSaveProfile = () => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `saveProfile`;
            apiPartners.setProfile(partner.data.id, partner.data.profile)
                .then(() => notifySuccess("Profile saved"))
                .catch(err => notifyNetworkError("Failed to update profile", err))
                .finally(() => inProgressAction.value = null);
        };
        const docTypes = {
            'LOGO': 'Logo',
            'CASEWORKER_AUTH_LETTER': 'Caseworker auth letter'
        };
        const deleteDocument = (doc, type) => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `deleteDocument`;
            apiPartners.deleteAttachment(partner.data.id, doc.id)
                .then(() => {
                delete partner.data.attachments[type];
                notifySuccess("Document deleted");
            })
                .catch(err => notifyNetworkError("Failed to delete document", err))
                .finally(() => inProgressAction.value = null);
        };
        const uploadDocument = (uploadInfo, type) => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `uploadDocument`;
            apiPartners.uploadAttachment(partner.data.id, type, uploadInfo.file)
                .then(doc => {
                partner.data.attachments[type] = doc;
                notifySuccess("Document uploaded");
            })
                .catch(err => notifyNetworkError("Failed to upload document", err))
                .finally(() => {
                inProgressAction.value = null;
                uploadInfo.onDone();
            });
        };
        const downloadDocument = (doc) => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `downloadDocument`;
            apiPartners.getAttachmentViewLink(partner.data.id, doc.id)
                .then((attachmentViewLink) => window.open(attachmentViewLink))
                .catch(err => notifyNetworkError("Failed to download attachment", err))
                .finally(() => inProgressAction.value = null);
        };
        const savePreferences = () => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `savePreferences`;
            apiPartners.setPreferences(partner.data.id, partner.data.preferences)
                .then(() => notifySuccess("Preferences saved"))
                .catch(err => notifyNetworkError("Failed to update preferences", err))
                .finally(() => inProgressAction.value = null);
        };
        const saveAdminSettings = () => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `saveAdminSettings`;
            apiPartners.setAdminSettings(partner.data.id, partner.data.adminSettings)
                .then(() => notifySuccess("Admin settings saved"))
                .catch(err => notifyNetworkError("Failed to update admin settings", err))
                .finally(() => inProgressAction.value = null);
        };
        const saveShownStatus = () => {
            if (inProgressAction.value)
                return;
            inProgressAction.value = `saveShownStatus`;
            apiPartners.setShownStatus(partner.data.id, partner.data.shown)
                .then(() => notifySuccess("Shown status saved"))
                .catch(err => notifyNetworkError("Failed to update shown status", err))
                .finally(() => inProgressAction.value = null);
        };
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_HeaderSectionLayout = _resolveComponent("HeaderSectionLayout");
            const _component_TabsHeader = _resolveComponent("TabsHeader");
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_FormCheckboxField = _resolveComponent("FormCheckboxField");
            const _component_CommentSection = _resolveComponent("CommentSection");
            const _component_TaskSection = _resolveComponent("TaskSection");
            const _component_FormNumberField = _resolveComponent("FormNumberField");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(isFeatureEnabled)('SITES'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_unref(partner).status == 'loading')
                            ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                            : (_unref(partner).status == 'ready')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _createVNode(_component_HeaderSectionLayout, null, {
                                        title: _withCtx(() => [
                                            _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(partner).data.name), 1)
                                        ]),
                                        fields: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_4, [
                                                _createElementVNode("div", _hoisted_5, [
                                                    _hoisted_6,
                                                    _createElementVNode("span", null, _toDisplayString(_unref(partner).data.pairingCode), 1)
                                                ])
                                            ])
                                        ]),
                                        networkAdminControls: _withCtx(() => [
                                            (_unref(isNetworkAdmin)())
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                                    _createElementVNode("article", _hoisted_8, [
                                                        _hoisted_9,
                                                        _createElementVNode("div", _hoisted_10, [
                                                            (_unref(partner).data.isPendingApproval)
                                                                ? (_openBlock(), _createBlock(_component_SaveButton, {
                                                                    key: 0,
                                                                    label: "Approve",
                                                                    icon: "fa-check",
                                                                    action: "approvePartner",
                                                                    inProgressAction: inProgressAction.value,
                                                                    onClick: _cache[0] || (_cache[0] = ($event) => (approvePartnerModalActive.value = true))
                                                                }, null, 8, ["inProgressAction"]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        partnerControls: _withCtx(() => []),
                                        _: 1
                                    }),
                                    _createVNode(_component_TabsHeader, {
                                        modelValue: activeTab.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((activeTab).value = $event)),
                                        tabs: Tab,
                                        entityType: _unref(Core).EntityType['Partner'],
                                        entityId: _unref(partner).data.id
                                    }, null, 8, ["modelValue", "entityType", "entityId"]),
                                    (activeTab.value == Tab.DETAILS)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                            _hoisted_12,
                                            _createElementVNode("div", _hoisted_13, [
                                                _createVNode(_component_FormTextField, {
                                                    label: "Building Number",
                                                    modelValue: _unref(partner).data.profile.address.number,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(partner).data.profile.address.number) = $event))
                                                }, null, 8, ["modelValue"]),
                                                _createVNode(_component_FormTextField, {
                                                    label: "Street",
                                                    modelValue: _unref(partner).data.profile.address.street,
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(partner).data.profile.address.street) = $event))
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createVNode(_component_FormTextField, {
                                                    label: "City",
                                                    modelValue: _unref(partner).data.profile.address.city,
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(partner).data.profile.address.city) = $event))
                                                }, null, 8, ["modelValue"]),
                                                _createVNode(FormSelectField, {
                                                    label: "State",
                                                    modelValue: _unref(partner).data.profile.address.state,
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(partner).data.profile.address.state) = $event)),
                                                    options: _unref(ProfileTypes).StateNotUnknown
                                                }, null, 8, ["modelValue", "options"])
                                            ]),
                                            _createElementVNode("div", _hoisted_15, [
                                                _createVNode(_component_FormTextField, {
                                                    label: "Postal Code",
                                                    modelValue: _unref(partner).data.profile.address.postalCode,
                                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(partner).data.profile.address.postalCode) = $event)),
                                                    numeric: "",
                                                    length: 9
                                                }, null, 8, ["modelValue"]),
                                                _createVNode(_component_FormTextField, {
                                                    label: "Country",
                                                    modelValue: _unref(partner).data.profile.address.country,
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(partner).data.profile.address.country) = $event))
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _createVNode(_component_SaveButton, {
                                                label: "Save Profile",
                                                action: "saveProfile",
                                                icon: "fa-save",
                                                inProgressAction: inProgressAction.value,
                                                onClick: _cache[8] || (_cache[8] = ($event) => (saveProfile()))
                                            }, null, 8, ["inProgressAction"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (activeTab.value == Tab.ATTACHMENTS)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _hoisted_17,
                                            _createElementVNode("div", _hoisted_18, [
                                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(docTypes, (docTypeLabel, docTypeId) => {
                                                    return _createElementVNode("div", {
                                                        class: "column",
                                                        key: docTypeId
                                                    }, [
                                                        _createElementVNode("label", _hoisted_19, _toDisplayString(docTypeLabel), 1),
                                                        _createVNode(DocumentUploadWidget, {
                                                            singleDocument: _unref(partner).data.attachments[docTypeId],
                                                            onDelete: ($event) => (deleteDocument($event, docTypeId)),
                                                            onUpload: ($event) => (uploadDocument($event, docTypeId)),
                                                            onView: _cache[9] || (_cache[9] = ($event) => (downloadDocument($event)))
                                                        }, null, 8, ["singleDocument", "onDelete", "onUpload"])
                                                    ]);
                                                }), 64))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (activeTab.value == Tab.PREFERENCES)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _hoisted_21,
                                            _createVNode(FormStringListField, {
                                                label: "Notary Emails",
                                                icon: "fa-envelope",
                                                modelValue: _unref(partner).data.preferences.notifications.notaryEmails,
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_unref(partner).data.preferences.notifications.notaryEmails) = $event))
                                            }, null, 8, ["modelValue"]),
                                            _createVNode(_component_SaveButton, {
                                                action: "savePreferences",
                                                icon: "fa-save",
                                                inProgressAction: inProgressAction.value,
                                                onClick: _cache[11] || (_cache[11] = ($event) => (savePreferences()))
                                            }, null, 8, ["inProgressAction"]),
                                            (_unref(canSeeFeature)('partners'))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                    _hoisted_23,
                                                    _hoisted_24,
                                                    _createElementVNode("div", _hoisted_25, [
                                                        _createElementVNode("div", _hoisted_26, [
                                                            _createVNode(_component_FormCheckboxField, {
                                                                boxLabel: "Show In App",
                                                                modelValue: _unref(partner).data.shown,
                                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_unref(partner).data.shown) = $event))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_SaveButton, {
                                                                        action: "saveShownStatus",
                                                                        icon: "fa-save",
                                                                        inProgressAction: inProgressAction.value,
                                                                        onClick: _cache[12] || (_cache[12] = ($event) => (saveShownStatus())),
                                                                        style: { "margin-top": "5px" }
                                                                    }, null, 8, ["inProgressAction"])
                                                                ]),
                                                                _: 1
                                                            }, 8, ["modelValue"])
                                                        ])
                                                    ]),
                                                    _hoisted_27,
                                                    _hoisted_28,
                                                    _createElementVNode("div", _hoisted_29, [
                                                        _createElementVNode("div", _hoisted_30, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Feature).Type, (feature) => {
                                                                return (_openBlock(), _createElementBlock("div", { key: feature }, [
                                                                    _createVNode(FormSelectField, {
                                                                        label: feature,
                                                                        options: _unref(Feature).Status,
                                                                        modelValue: _unref(partner).data.adminSettings.enabledModules[feature],
                                                                        "onUpdate:modelValue": ($event) => ((_unref(partner).data.adminSettings.enabledModules[feature]) = $event)
                                                                    }, null, 8, ["label", "options", "modelValue", "onUpdate:modelValue"])
                                                                ]));
                                                            }), 128))
                                                        ])
                                                    ]),
                                                    _createVNode(_component_SaveButton, {
                                                        action: "saveAdminSettings",
                                                        icon: "fa-save",
                                                        inProgressAction: inProgressAction.value,
                                                        onClick: _cache[14] || (_cache[14] = ($event) => (saveAdminSettings()))
                                                    }, null, 8, ["inProgressAction"])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (activeTab.value == Tab.COMMENTS)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                            _createVNode(_component_CommentSection, {
                                                getComments: () => _unref(apiPartners).getComments(_unref(partner).data.id),
                                                addComment: (message, attachments, notifyCaseworker) => _unref(apiPartners).addComment(_unref(partner).data.id, message, attachments, notifyCaseworker),
                                                getAttachmentViewLink: (commentId, attachmentId) => _unref(apiPartners).getCommentAttachmentViewLink(_unref(partner).data.id, commentId, attachmentId)
                                            }, null, 8, ["getComments", "addComment", "getAttachmentViewLink"])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (activeTab.value == Tab.TASKS)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                            _createVNode(_component_TaskSection, {
                                                allowShowAll: "",
                                                getTasks: () => _unref(apiPartners).getTasks(_unref(partner).data.id),
                                                addTask: (audience, message) => _unref(apiPartners).addTask(_unref(partner).data.id, audience, message)
                                            }, null, 8, ["getTasks", "addTask"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_ModalDialog, {
                    active: approvePartnerModalActive.value,
                    title: "Approve Partner",
                    "allow-close": true,
                    onClose: _cache[19] || (_cache[19] = ($event) => (approvePartnerModalActive.value = false)),
                    "first-button-text": "Go Back",
                    "first-button-severity": "link",
                    onFirstbuttonselected: _cache[20] || (_cache[20] = ($event) => (approvePartnerModalActive.value = false)),
                    "second-button-text": "Approve",
                    "second-button-severity": "primary",
                    loading: inProgressAction.value == 'approvePartner',
                    onSecondbuttonselected: _cache[21] || (_cache[21] = ($event) => (approvePartner()))
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_33, [
                                _createVNode(FormSelectField, {
                                    label: "Plan",
                                    modelValue: partnerApproval.value.subscriptionConfig.plan,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((partnerApproval.value.subscriptionConfig.plan) = $event)),
                                    options: _unref(PartnerPlan),
                                    allowNullSelection: ""
                                }, null, 8, ["modelValue", "options"]),
                                _createVNode(FormSelectField, {
                                    label: "Start Billing From",
                                    modelValue: partnerApproval.value.subscriptionConfig.trialEndDate,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((partnerApproval.value.subscriptionConfig.trialEndDate) = $event)),
                                    options: availableTrialEndDates,
                                    allowNullSelection: "",
                                    nullSelectionLabel: "Immediately"
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                                _createVNode(_component_FormTextField, {
                                    label: "Stripe Customer ID",
                                    placeholder: "Leave blank to create new",
                                    modelValue: partnerApproval.value.subscriptionConfig.stripeCustomerId,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((partnerApproval.value.subscriptionConfig.stripeCustomerId) = $event))
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_FormNumberField, {
                                    label: "Account Credit ($)",
                                    modelValue: partnerApproval.value.subscriptionConfig.accountCredit,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((partnerApproval.value.subscriptionConfig.accountCredit) = $event)),
                                    validator: _unref(partnerApprovalValidator)(_unref(Validations).notEmpty, _unref(Validations).number)
                                }, null, 8, ["modelValue", "validator"])
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["active", "loading"])
            ], 64));
        };
    }
});
